import {
    BehaviorSubject
} from 'rxjs';

/**
 *
 * @module ObservationCenter
 * @desc Container for observable BehaviorSubjects (@see https://rxjs-dev.firebaseapp.com/api/index/class/BehaviorSubject)
 * @class ObservationCenter
 *
 */
class ObservationCenter {

    constructor() {

        /**
         *
         * @desc Observable subject for the player's state
         * @type {Rxjs.BehaviorSubject}
         *
         */
        this.stateSubject = new BehaviorSubject({
            type: 'empty',
        });

        /**
         *
         * @desc Observable subject for the player
         * @type {Rxjs.BehaviorSubject}
         *
         */
        this.playerSubject = new BehaviorSubject({
            type: 'empty',
        });

        /**
         *
         * @desc Observable subject for the player time updates
         * @type {Rxjs.BehaviorSubject}
         *
         */
        this.playerTimeSubject = new BehaviorSubject({
            type: 'empty',
        });

        /**
         *
         * @desc Observable subject for plugins
         * @type {Rxjs.BehaviorSubject}
         *
         */
        this.pluginSubject = new BehaviorSubject({
            type: 'empty',
        });

        /**
         *
         * @desc Observable subject for controls
         * @type {Rxjs.BehaviorSubject}
         *
         */
        this.controlsSubject = new BehaviorSubject({
            type: 'empty',
        });

    }

}

export default ObservationCenter;
